<template>
  <div>
    <!-- 头部 开始 -->
    <header class="module-layer">
      <div class="module-layer-content">
        <div class="logo">
          <p>雍荷堂</p>
        </div>
        <div class="icon">
        	<a href="javascript:;">
        	<img src="../assets/images/avatar.png"></a>
        </div>
      </div>
    </header>
    <!-- 头部 结束 -->

    <!-- 主体 开始 -->
    <div class="layout-container" style="min-height: 657px;">
      <div class="list">
        <ul>
          <category v-for="(item,index) in items" :item="item" :key="index"></category>
        </ul>
      </div>
    </div>
    <!-- 主体 结束 -->
  </div>
</template>

<script>
import Category from "../components/Category"; // 引入子组件
import { getCategoryList } from '@/api/api'

export default {
  name: "Home",
  components: { Category },
  data() {
    return {
      items: []
    };
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      getCategoryList().then(response => {
        this.items = response.data
      })
    }
  }
};
</script>


<style scoped>
.module-layer-content {
  background-color: #2a2a2a;
}
.list ul li {
  margin: 0.1px 0.1px 0.1px 0.1px;
}
.icon {
    position: absolute;
    right: 0;
    top: 0;
}
.icon a img {
    display: inline-block;
    vertical-align: middle;
    width: .16rem;
    height: .16rem;
    margin-right: .06rem;
    margin-top: .13rem;
}
</style>